export const STATEMENT_SIDE_MENU_TOGGLE_MUTATION = "STATEMENT_SIDE_MENU_TOGGLE_MUTATION";
export const STATEMENT_SIDE_MENU_OPEN_MUTATION = "STATEMENT_SIDE_MENU_OPEN_MUTATION";

export const PROGRESS_START_MUTATION = "PROGRESS_START_MUTATION";
export const PROGRESS_END_MUTATION = "PROGRESS_END_MUTATION";
//신규
export const STATEMENT_STATUS_LIST_MUTATION = "STATEMENT_STATUS_LIST_MUTATION";
